import { SignupPayload } from '../../Views/Blocks/SignupBlock/classes/SignupPayload';
import { ConvertTracker } from './ConvertTracker';
import { DataLayerPusherSignupTracker } from './DataLayerPusherSignupTracker';
import { HeapTracker } from './HeapTracker';
import { MarketingAutomationSubmissionType, Tracker } from './tracker';

export class TrackerComposite implements Tracker {
  constructor(private readonly trackers: ReadonlyArray<Tracker>) {}

  async fireSignupSuccess(
    signupData: SignupPayload,
    teamSize: number,
  ): Promise<void> {
    await Promise.all(
      this.trackers.map((tracker) =>
        tracker.fireSignupSuccess(signupData, teamSize),
      ),
    );
  }

  async fireSignupStep(step: number): Promise<void> {
    await Promise.all(
      this.trackers.map((tracker) => tracker.fireSignupStep(step)),
    );
  }

  async fireMarketingAutomationSubmission(
    type: MarketingAutomationSubmissionType,
  ): Promise<void> {
    await Promise.all(
      this.trackers.map((tracker) =>
        tracker.fireMarketingAutomationSubmission(type),
      ),
    );
  }
}

const trackerCollection = new TrackerComposite([
  new DataLayerPusherSignupTracker(),
  new HeapTracker(),
  new ConvertTracker(),
]);

export function fireSignupTrackingEvents(
  signupData: SignupPayload,
  teamSize: number,
): Promise<void> {
  return trackerCollection.fireSignupSuccess(signupData, teamSize);
}

export function fireSignupStep(step: number): Promise<void> {
  return trackerCollection.fireSignupStep(step);
}

export function fireMarketingAutomationSubmission(
  type: MarketingAutomationSubmissionType,
): Promise<void> {
  return trackerCollection.fireMarketingAutomationSubmission(type);
}
